/**
 * Pastilles à initiales (livreurs, gestionnaires).
 *
 * Chaque profil portait autrefois sa propre couleur. Elle n'encodait rien :
 * le nom figure toujours à côté de la pastille, et la carte GPS colore ses
 * marqueurs selon le statut en ligne / hors ligne, jamais selon le livreur.
 * Une teinte unique calme les listes sans rien faire perdre.
 */
export const AVATAR_BG = '#eef4ff';
export const AVATAR_FG = '#173b78';
